module.exports = __webpack_public_path__ + "static/media/OPN_330.c5e2ab85.png";